
















































import Vue from "vue";
import VScroller from "@/components/table/VScroller.vue";
import { state } from "./data/state";
import { FamiliarityItem } from "./data/models";
import UnmanagedItem from "./UnmanagedItem.vue";

import { remToPx } from "@/common/dom.functions";
import { UsePopup } from "@/components/root/popup/popup.state";
import { computed } from "@vue/composition-api";
import { POPULATION_TYPE } from "@/common/models";
export default Vue.extend({
  components: {
    VScroller,
    UnmanagedItem,
  },
  setup() {
    const {
      current_display_list: entities,
      is_loading_unmanaged_entities: is_loading,
      load_more_items,
      unmanaged_entities_count,
      selected_entity_type,
      investigate_entity,
      current_tab,
      manage_trust,
      show_events_modal,
      affinity_levels,
      set_selected_affinity_level,
    } = state;

    const is_departments = computed(
      () => selected_entity_type.value.id === POPULATION_TYPE.DEPARTMENT
    );

    const manage = async (item: FamiliarityItem) => {
      await manage_trust(item);
    };

    const show_events_for_entity = async (entity: FamiliarityItem) => {
      await show_events_modal(entity);
    };

    const show_affinity_popup = async (event: MouseEvent) => {
      const res = await UsePopup.showActionPopup({
        type: "TextDisplayPopup",
        items: affinity_levels.value.map((d) => d.name),
        position: "bottom",
        event,
        width: remToPx(13),
      });
      if (res.type === "success") {
        const selected_affinity_id = affinity_levels.value.find(
          (d) => d.name === res.action
        )?.id as string;
        set_selected_affinity_level(selected_affinity_id);
      }
    };

    return {
      is_loading,
      entities,
      load_more_items,
      is_departments,
      investigate_entity,
      count: unmanaged_entities_count,
      current_tab,
      manage,
      selected_entity_type,
      show_events_for_entity,
      show_affinity_popup,
    };
  },
});
